import { z } from 'zod';
import { baseTaskSchema } from '../schema.base.js';
import { textCorrectionInput } from './input.text-correction.js';

const textCorrectionTaskSchema = baseTaskSchema.extend({
  taskType: z.literal("TextCorrection"),
  correctAnswer: z.array(z.object({
    title: z.string(),
    text: z.string()
  })),
  text: textCorrectionInput.schema
}).transform(({
  text,
  correctAnswer,
  ...rest
}) => ({
  ...rest,
  content: [textCorrectionInput.postprocessSchemaInput(text, {
    taskId: rest.id,
    correctAnswer
  })]
}));

export { textCorrectionTaskSchema };
//# sourceMappingURL=_schema.js.map
